import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useBrandGuidelines } from "@modules/ECMS/CORPORATE/Forms/MediaCentre/Media.hook";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { Button, Tabs } from "antd";
import { useNavigate } from "react-router-dom";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { ManagementIntegrityMessagePageContent } from "./ManagementIntegrityMessagePageContent";
import { ManagementIntegrityMessagePageHeading } from "./ManagementIntegrityMessagePageHeading";
import { ManagementIntegrityMessageNextPage } from "./ManagementIntegrityNextPage";

export const ManagementIntegrityMessage = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();

  const items = [
    {
      label: "Page Heading",
      key: "managementIntegrityMessagePageHeading",
      children: <ManagementIntegrityMessagePageHeading/>
    }, 
    {
      label: "Page Content",
      key: "managementIntegrityMessagePageContent",
      children: <ManagementIntegrityMessagePageContent/>
    },
    {
      label: "Next Page",
      key: "managementIntegrityMessageNextPage",
      children: <ManagementIntegrityMessageNextPage/>
    },
  ];

  return (
    <>
      <Tabs
        activeKey={query?.get("subActiveTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${query.get("activeTab")}&subActiveTab=${activeKey}`, { replace: true });
        }}
      ></Tabs>
    </>
  );
};
